module.exports = __webpack_public_path__ + "img/CHEVRON_RIGHT.bd5a5e6d.svg";